module.exports = __webpack_public_path__ + "media/images/btn-arrow-right-326f231cee31229a338d6631025b3032.svg";